import React, { useEffect, useState } from "react";
import { TableCell, TableRow, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateDDP } from "../Redux/Reducer/DDPReducer";
const rowHeight = 5;

const fontStyle = {
  // fontFamily: "Inter",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  letterSpacing: "-0.387px",
  color: "#000",
};

const textFieldStyle = {
  height: rowHeight,
  color: "#62696b",
  input: { textAlign: "center" },
};

const textFieldInput = {
  style: { height: rowHeight + 12, padding: "0px" },
};

const LocalTaxes = ({ countryNames, vatData, setVatUpdatedData , currency}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [totals, setTotals] = useState([]);
  const [showRow, setShowRow] = useState(true);
  const [TAX, setTax] = useState([]);
  const DDU = useSelector((state) => state.DDUData.DDU);

  // useEffect(() => {
  //   if (TAX.length < 1) return;

  //   const tariffValue =
  //     TAX.length > 0 &&
  //     TAX.filter(
  //       (ele) =>
  //         ele.Material === selectedMaterial &&
  //         ele["Destination Country"].toLocaleLowerCase() ===
  //           selectedHeader.toLocaleLowerCase()
  //     );

  //   const VATValue = countryNames.map((country) => {
  //     const matchingData =
  //       tariffValue &&
  //       tariffValue.find(
  //         (data) =>
  //           data["Origin Country"].toLowerCase() === country.toLowerCase()
  //       );

  //     const countryName = matchingData
  //       ? matchingData["Origin Country"].toLowerCase()
  //       : selectedHeader.toLowerCase();

  //     const countryValue = (DDU.length > 0 && DDU[0][countryName]) || 0;
  //     const vatValue =
  //       matchingData && matchingData.VAT
  //         ? parseFloat((countryValue * parseFloat(matchingData.VAT)) / 100 || 0)
  //         : 0;

  //     return {
  //       Country: matchingData ? matchingData["Origin Country"] : selectedHeader,
  //       VAT: matchingData && matchingData.VAT ? matchingData.VAT : 0,
  //       VATValue: vatValue ? vatValue : 0,
  //     };
  //   });

  //   const dataResult = Array.isArray(VATValue)
  //     ? VATValue.map((item) => {
  //         if (
  //           item.Country &&
  //           selectedHeader &&
  //           item.Country.toLowerCase() === selectedHeader.toLowerCase()
  //         ) {
  //           return {
  //             Country: item.Country,
  //             VAT: 0,
  //             VATValue: "NA",
  //           };
  //         }
  //         return item;
  //       })
  //     : [];

  //   setData(dataResult);
  // }, [countryNames, selectedData, DDU, TAX]);

  useEffect(() => {
    const response = countryNames.map((country) => {
      const countryData = vatData?.find(
        (ele) => ele?.country?.toLowerCase() === country?.toLowerCase()
      );
      const dduObject = DDU.length > 0 ? DDU[0] : {};
      const normalizedKeys = Object.keys(dduObject).reduce((acc, key) => {
        acc[key.toLowerCase()] = dduObject[key];
        return acc;
      }, {});

      const countryKey = country.toLowerCase();
      const countryValue = normalizedKeys[countryKey] || 0;

      // If countryData is missing → fallback to 0
      const vatPercent = countryData?.vat ? parseFloat(countryData.vat) : 0;
      const vatValue = (countryValue * vatPercent) / 100;
      // const vatValue =
      //   parseFloat((countryValue * parseFloat(countryData?.vat)) / 100 || 0) ??
      //   0;

      return {
        Country: country,
        VAT: vatPercent,
        VATValue: vatValue || 0,
      };
    });

    setData(response);
    // vatData;
  }, [vatData, countryNames, DDU]);

  const handleChange = (event, index, field) => {
    const updatedData = [...data];
    updatedData[index][field] = event.target.value;
    setData(updatedData);
    updateTotals(updatedData);
  };

  const updateTotals = (updatedData) => {
    if (updatedData.length < 1) return;
    const countryTotals = updatedData.reduce((acc, row) => {
      const countryName =
        row?.Country &&
        row?.Country?.charAt(0).toUpperCase() + row?.Country?.slice(1);

      const normalizedCountryName =
        countryName && countryName.trim().toLowerCase();

      const matchedKey = Object.keys(DDU[0]).find(
        (key) => key.trim().toLowerCase() === normalizedCountryName
      );

      const countryValue = matchedKey ? DDU[0][matchedKey] : undefined;

      const total = parseFloat(
        countryValue + (countryValue * parseFloat(row.VAT)) / 100
      );
      const roundedTotal = parseFloat(total.toFixed(1));
      acc[countryName] = roundedTotal;

      return acc;
    }, {});

    const newTotals = Object.values(countryTotals);

    setTotals(newTotals);
    dispatch(updateDDP(countryTotals));
  };

  React.useEffect(() => {
    data.length > 0 && updateTotals(data);
  }, [data, DDU]);

  function handleAddRow() {
    setShowRow(!showRow);
  }

  useEffect(() => {
    setVatUpdatedData(data);
  }, [data]);

  return (
    <>
      <TableRow className="row-gap"></TableRow>
      <TableRow
        className={`row-height first-row ${!showRow ? "" : "fade-row"}`}
      >
        <TableCell className="row-height sticky-cell cell-height first-row">
          <span className="label_style"> VAT/Local Taxes</span>
        </TableCell>
        {data.map((row, index) => (
          <TableCell
            className="row-height cell-height  first-row"
            key={index}
            align="center"
          >
            {row.isEditingVAT ? (
              <TextField
                value={row.VAT}
                onChange={(event) => handleChange(event, index, "VAT")}
                // type="number"
                sx={textFieldStyle}
                InputProps={textFieldInput}
              />
            ) : // parseFloat(row.VAT).toFixed(1) + "%"
            !isNaN(row.VATValue) ? (
              parseFloat(row.VATValue).toFixed(1)
            ) : (
              "N/A"
            )}
          </TableCell>
        ))}
        <TableCell className="row-height cell-height sticky-button  first-row"></TableCell>
      </TableRow>

      <TableRow style={{ position: "relative" }}>
        <TableCell className="row-height main-cell sticky-cell">
          <span style={{ display: "flex", justifyContent: "space-between" }}>
            <span className="label_style">DDP</span>
            {/* <span>($/MT)</span> */}
            <span>({currency.currency_symbol}/MT)</span>
          </span>
        </TableCell>

        {totals.length > 0 &&
          totals.map((total, index) => (
            <TableCell
              className={`row-height main-cell`}
              key={index}
              align="center"
            >
              {total.toFixed(1)}
            </TableCell>
          ))}
        {showRow ? (
          <TableCell
            className="row-height main-cell sticky-button"
            onClick={handleAddRow}
          >
            +
          </TableCell>
        ) : (
          <TableCell
            className="row-height main-cell sticky-button"
            onClick={handleAddRow}
          >
            -
          </TableCell>
        )}
      </TableRow>
    </>
  );
};

export default LocalTaxes;
